/**
 * AGENTS MODAL TABLE
 */

export const agentTableKey = {
  AGENT: 'name',
  CITY: 'city',
  QUANTITY: 'qty',
  TAG: 'tags',
};

export const agentTableHeader = {
  [agentTableKey.AGENT]: 'Representante',
  [agentTableKey.CITY]: 'Cidade - UF',
  [agentTableKey.QUANTITY]: 'Quantidade',
  [agentTableKey.TAG]: 'Tag',
};

export const agentTableHeaderV2 = {
  [agentTableKey.AGENT]: 'Representante',
  [agentTableKey.CITY]: 'Cidade - UF',
  [agentTableKey.QUANTITY]: 'Quantidade',
  [agentTableKey.TAG]: 'Categoria',
};

/**
 * MATERIAL MODAL TABLE
 */

export const materialTableKey = {
  MATERIAL: 'name',
  MATERIAL_TYPE: 'materialTypeCategory',
  QUANTITY: 'availableQuantity',
};

export const materialTableHeader = {
  [materialTableKey.MATERIAL]: 'Material',
  [materialTableKey.MATERIAL_TYPE]: 'Tipo',
  [materialTableKey.QUANTITY]: 'Quantidade',
};

/**
 * PRODUCT MODAL TABLE
 */

export const productTableKey = {
  PRODUCT: 'name',
};

export const productTableHeader = {
  [productTableKey.PRODUCT]: 'Material',
};

/**
 * PRODUCT TYPES
 */
export const productType = {
  NAME: 'name',
  CODE: 'code',
};

export const productTypeLabel = {
  [productType.NAME]: 'Nome',
  [productType.CODE]: 'Código',
};

export const productTypeOptionList = [
  {
    value: productType.NAME,
    label: productTypeLabel[productType.NAME],
  },
  {
    value: productType.CODE,
    label: productTypeLabel[productType.CODE],
  },
];

export const materialValidationType = {
  EXCEEDS_AVAILABLE: 'EXCEEDS_AVAILABLE',
  INVALID_PACKING_QUANTITY: 'INVALID_PACKING_QUANTITY',
  VALID_PACKING_QUANTITY: 'VALID_PACKING_QUANTITY',
  NONE: '',
};

/**
 * MATERIAL VALIDATION TYPES
 */

export const materialValidationMessage = {
  [materialValidationType.EXCEEDS_AVAILABLE]:
    'Informe uma quantidade válida de acordo com o valor total. Tente novamente',
  [materialValidationType.INVALID_PACKING_QUANTITY]:
    'Informe uma quantidade válida de acordo com o valor por caixa. Tente novamente',
  [materialValidationType.VALID_PACKING_QUANTITY]: (caixas) =>
    `Quantidade de embalagens: ${caixas}`,
  [materialValidationType.NONE]: '',
};
